import { Route, Switch, Redirect } from 'react-router-dom';
import React from 'react';
// import ChangePasswordComponent from '../pages/security/ChangePassword';
import DashboardComponent from './dashboard/dashboard';
import NewSchemaListComponent from './schema/newSchemaList';
import BPMComponent from './BPM/BPM';
import PageListComponent from './pagelist/List';
import UserComponent from '../pages/Admin/User/User';
import RoleListComponent from '../pages/Admin/Role/RoleList';
import SettingComponent from '../pages/Admin/Setting/Setting';
import { JwtServices } from '../services/jwt.services';
import ClusterComponent from './Admin/Cluster';
import ClusterCompareMultiSelect from './Admin/Cluster/ClusterCompareMultiSelect/ClusterCompareMultiSelect';
import ClusterComparison from './Admin/Cluster/ClusterCompare/ClusterCompare';
import SharingComponent from './DataSharings'


const jwtServices = new JwtServices();
const PrivateRoute = ({ component: Component, ...rest }: any) => (

    <Route {...rest} render={(props) => (
        jwtServices.isLogin() === true
            ? <Component {...props} />
            : <Redirect to='/login' />
    )} />

)

const PageRoute = (props: any) => {
    return (
        <Switch>
            <PrivateRoute exact path={`${props.match.path}/dashboard`} component={DashboardComponent} />
            <PrivateRoute exact path={`${props.match.path}/list`} component={PageListComponent} />
            {/* <PrivateRoute exact path={`${props.match.path}/schema-list`} component={SchemaListComponent} />  */}
            <PrivateRoute exact path={`${props.match.path}/schema-list`} component={NewSchemaListComponent} />
            <PrivateRoute exact path={`${props.match.path}/bpm`} component={BPMComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin`} component={UserComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin/users`} component={UserComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin/roles`} component={RoleListComponent} />
            <PrivateRoute exact path={`${props.match.path}/networking`} component={SharingComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin/settings`} component={SettingComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin/clusters`} component={ClusterComponent} />
            <PrivateRoute exact path={`${props.match.path}/admin/clusters/compare`} component={ClusterCompareMultiSelect} />
            <PrivateRoute exact path={`${props.match.path}/admin/clusters/compare/comparison`} component={ClusterComparison} />
            <Redirect to={`${props.match.path}/dashboard`} />
        </Switch>

    )
}

export default PageRoute;